import { URLS } from '../constants'
import { dispatchFetchGet, dispatchFetchPost, dispatchFetchPut, dispatchFetchDelete } from './ActionsUtil'
import {
    SET_FILTERS_MODAL,
    GET_ALL_FILTERS_BEGIN, GET_ALL_FILTERS_SUCCESS, GET_ALL_FILTERS_FAILURE,
    GET_FILTER_BEGIN, GET_FILTER_SUCCESS, GET_FILTER_FAILURE,
    POST_FILTER_BEGIN, POST_FILTER_SUCCESS, POST_FILTER_FAILURE,
    PUT_FILTER_BEGIN, PUT_FILTER_SUCCESS, PUT_FILTER_FAILURE,
    DELETE_FILTER_BEGIN, DELETE_FILTER_SUCCESS, DELETE_FILTER_FAILURE,
    GET_FILTERED_USERS_BEGIN, GET_FILTERED_USERS_SUCCESS, GET_FILTERED_USERS_FAILURE
} from '../constants/ActionTypes'

export const acSetFiltersModal = payload => ({ type: SET_FILTERS_MODAL, payload: payload })

const acGetAllFiltersBegin = () => ({ type: GET_ALL_FILTERS_BEGIN })
const acGetAllFiltersSuccess = payload => ({ type: GET_ALL_FILTERS_SUCCESS, payload: { response: payload } })
const acGetAllFiltersFailure = err => ({ type: GET_ALL_FILTERS_FAILURE, payload: err })

export const acGetAllFilters = () => {
    return dispatchFetchGet(
        `${URLS.FILTER.ROOT}`,
        acGetAllFiltersBegin,
        acGetAllFiltersSuccess,
        acGetAllFiltersFailure
    )
}

const acGetFilterBegin = () => ({ type: GET_FILTER_BEGIN })
const acGetFilterSuccess = payload => ({ type: GET_FILTER_SUCCESS, payload: { response: payload } })
const acGetFilterFailure = err => ({ type: GET_FILTER_FAILURE, payload: err })

export const acGetFilter = (id) => {
    return dispatchFetchGet(
        `${URLS.FILTER.ROOT}/${id}`,
        acGetFilterBegin,
        acGetFilterSuccess,
        acGetFilterFailure
    )
}

const acPostFilterBegin = () => ({ type: POST_FILTER_BEGIN })
const acPostFilterSuccess = payload => ({ type: POST_FILTER_SUCCESS, payload: { response: payload } })
const acPostFilterFailure = err => ({ type: POST_FILTER_FAILURE, payload: err })

export const acPostFilter = (
    name, description,
    register_period_begin, register_period_end, register_last_days, register_days_ago,
    desire_plan_situation, active_plan,
    desire_consult_situation, consults_sign, consults_number, consults_number_2,
    consult_period_begin, consult_period_end, consult_last_days,
    desire_different_targets_consult_situation, different_targets_consult_sign, different_targets_consult_number_2,
    desire_credit_purchase_situation, credit_purchase_sign, credit_purchase_value, credit_purchase_value_2,
    credit_purchase_period_begin, credit_purchase_period_end, credit_purchase_last_days,
    rd_event_name, rd_event_trigger_frequency_interval, rd_event_trigger_initial_date
) => {
    return dispatchFetchPost(
        `${URLS.FILTER.ROOT}`,
        {
            name, description,
            register_period_begin, register_period_end, register_last_days, register_days_ago,
            desire_plan_situation, active_plan,
            desire_consult_situation, consults_sign, consults_number, consults_number_2,
            consult_period_begin, consult_period_end, consult_last_days,
            desire_different_targets_consult_situation, different_targets_consult_sign, different_targets_consult_number_2,
            desire_credit_purchase_situation, credit_purchase_sign, credit_purchase_value, credit_purchase_value_2,
            credit_purchase_period_begin, credit_purchase_period_end, credit_purchase_last_days,
            rd_event_name, rd_event_trigger_frequency_interval, rd_event_trigger_initial_date
        },
        acPostFilterBegin,
        acPostFilterSuccess,
        acPostFilterFailure
    )
}

const acPutFilterBegin = () => ({ type: PUT_FILTER_BEGIN })
const acPutFilterSuccess = payload => ({ type: PUT_FILTER_SUCCESS, payload: { response: payload } })
const acPutFilterFailure = err => ({ type: PUT_FILTER_FAILURE, payload: err })

export const acPutFilter = (
    id,
    name, description,
    register_period_begin, register_period_end, register_last_days, register_days_ago,
    desire_plan_situation, active_plan,
    desire_consult_situation, consults_sign, consults_number, consults_number_2,
    consult_period_begin, consult_period_end, consult_last_days,
    desire_different_targets_consult_situation, different_targets_consult_sign, different_targets_consult_number_2,
    desire_credit_purchase_situation, credit_purchase_sign, credit_purchase_value, credit_purchase_value_2,
    credit_purchase_period_begin, credit_purchase_period_end, credit_purchase_last_days,
    rd_event_name, rd_event_trigger_frequency_interval, rd_event_trigger_initial_date
) => {
    return dispatchFetchPut(
        `${URLS.FILTER.ROOT}/${id}`,
        {
            name, description,
            register_period_begin, register_period_end, register_last_days, register_days_ago,
            desire_plan_situation, active_plan,
            desire_consult_situation, consults_sign, consults_number, consults_number_2,
            consult_period_begin, consult_period_end, consult_last_days,
            desire_different_targets_consult_situation, different_targets_consult_sign, different_targets_consult_number_2,
            desire_credit_purchase_situation, credit_purchase_sign, credit_purchase_value, credit_purchase_value_2,
            credit_purchase_period_begin, credit_purchase_period_end, credit_purchase_last_days,
            rd_event_name, rd_event_trigger_frequency_interval, rd_event_trigger_initial_date
        },
        acPutFilterBegin,
        acPutFilterSuccess,
        acPutFilterFailure
    )
}

const acDeleteFilterBegin = () => ({ type: DELETE_FILTER_BEGIN })
const acDeleteFilterSuccess = payload => ({ type: DELETE_FILTER_SUCCESS, payload: { response: payload } })
const acDeleteFilterFailure = err => ({ type: DELETE_FILTER_FAILURE, payload: err })

export const acDeleteFilter = (id) => {
    return dispatchFetchDelete(
        `${URLS.FILTER.ROOT}/${id}`,
        acDeleteFilterBegin,
        acDeleteFilterSuccess,
        acDeleteFilterFailure
    )
}

const acGetFilteredUsersBegin = () => ({ type: GET_FILTERED_USERS_BEGIN })
const acGetFilteredUsersSuccess = payload => ({ type: GET_FILTERED_USERS_SUCCESS, payload: { response: payload } })
const acGetFilteredUsersFailure = err => ({ type: GET_FILTERED_USERS_FAILURE, payload: err })

export const acGetFilteredUsers = (id) => {
    return dispatchFetchGet(
        `${URLS.FILTER.ROOT}/${id}${URLS.FILTER.USERS}`,
        acGetFilteredUsersBegin,
        acGetFilteredUsersSuccess,
        acGetFilteredUsersFailure
    )
}